<template>
  <div class="show">
    {{ props.data.outIp || ' - ' }} | {{ props.data.area || ' - ' }}
  </div>
</template>

<script lang="ts" setup>
import { defineProps } from 'vue';
import { TextFieldType } from '@/components/business/crud/interface/FieldType';
import { WidgetInfo } from '@/components/business/crud/widgets/WidgetContainer';

const props = defineProps<{
  propName: string;
  widget: TextFieldType;
  info: WidgetInfo;
  data: any;
}>();
</script>

<style lang="scss" scoped>
.show {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
}
</style>
